import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../api";
import { message } from "antd";

// ------------------ Types ------------------
export type MemberAction = "create" | "update" | "delete";
export interface MemberPayload {
  action: MemberAction;
  member_id?: number | null;
  depot_ids?: number[]; // ✅ changed from depot_id to depot_ids (numeric array)
  member_first_name?: string;
  member_surname?: string;
  member_type?: number;
  preffered_comm_channel?: "Email" | "Mobile No" | "WhatsApp No";
  member_country_code?: string;
  member_mobile_no?: number;
  member_email_id?: string | null;
  profile_status_flg?: -1 | 0 | 1;
  reporting_member_id?: number;
  member_ids?: number[]; // ✅ used for bulk delete
  unit_group_ids?: number[]; // ✅ numeric array
  role_id?: number;
}

interface ApiResponse {
  statusCode: number;
  message: string;
}

// ------------------ API Function ------------------
export const updateMember = async (
  payload: MemberPayload
): Promise<ApiResponse> => {
  try {
    // ✅ Ensure all IDs are numbers
    const safePayload = {
      ...payload,
      depot_ids: payload.depot_ids?.map(Number),
      unit_group_ids: payload.unit_group_ids?.map(Number),
      member_ids: payload.member_ids?.map(Number),
      member_mobile_no: payload.member_mobile_no
        ? Number(payload.member_mobile_no)
        : undefined,
      member_type: payload.member_type
        ? Number(payload.member_type)
        : undefined,
      role_id: payload.role_id ? Number(payload.role_id) : undefined,
    };

    const { data } = await api.post<ApiResponse>("/members/v1", safePayload);
    return data;
  } catch (error: any) {
    const msg = error?.response?.data?.message || error?.message || "error";
    message.error(msg); //
    throw error; // rethrow so calling mutation can handle it too
  }
};

// ------------------ React Query Hook ------------------
export const useUpdateMember = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse, Error, MemberPayload>({
    mutationFn: updateMember,
    onSuccess: (_, variables) => {
      // ✅ Refresh list only for add/update
      if (variables.action !== "delete") {
        queryClient.invalidateQueries({ queryKey: ["members"] });
      }
    },
  });
};
